import React from "react";

function Footer() {
  return <div className="h-20 w-full bg-black text-white"></div>;
}

export default Footer;
